export default "__VITE_ASSET__BBp$8DMo__"